import React, { lazy, Suspense } from 'react';
import { Card, Tabs, LoadingSpinner } from 'components/common';
import { useSelector } from 'react-redux';
import { MdCheck, MdLeaderboard, MdNewReleases, MdOnlinePrediction, MdListAlt } from 'react-icons/md';
import LeadHeader from './LeadHeader';

const AllList = lazy(() => import('./list/All'));
const MqlList = lazy(() => import('./list/Mql'));
const SqlList = lazy(() => import('./list/Sql'));
const CreatedThisMonthList = lazy(() => import('./list/CreatedThisMonth'));
const OpportunityList = lazy(() => import('./list/Opportunity'));

const Leads = () => {
  const { loading } = useSelector((state) => state.crm_lead)

  const suspenseWrap = (child) => (
    <Suspense fallback={
      <div className="tw-text-center tw-my-2">
        <LoadingSpinner />
      </div>
    }>
      {child}
    </Suspense>
  );

  return (
    <>
      <LeadHeader />

      {loading &&
        <div className="tw-text-center tw-my-2">
          <LoadingSpinner />
        </div>
      }

      <Card padding="none">
        <Tabs
          variant="underline"
          lazyMount
          navClassName="tw-px-3 tw-pt-2 tw-bg-white"
          contentClassName="tw-bg-slate-50 tw-p-4"
          tabs={[
            {
              label: 'All',
              icon: <MdListAlt size={14} />,
              content: suspenseWrap(<AllList />),
            },
            {
              label: 'Created this month',
              icon: <MdNewReleases size={14} className="tw-text-yellow-500" />,
              content: suspenseWrap(<CreatedThisMonthList />),
            },
            {
              label: 'MQL',
              icon: <MdCheck size={14} />,
              content: suspenseWrap(<MqlList />),
            },
            {
              label: 'SQL',
              icon: <MdLeaderboard size={14} className="tw-text-yellow-500" />,
              content: suspenseWrap(<SqlList />),
            },
            {
              label: 'Opportunity',
              icon: <MdOnlinePrediction size={14} className="tw-text-yellow-500" />,
              content: suspenseWrap(<OpportunityList />),
            },
          ]}
        />
      </Card>
    </>
  )
}

export default Leads
